module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4096685381/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main